
<div class="stu-visibility-page" *ngIf="!submitting; else loadingTpl">
	<div class="stu-visibility-content" cdkScrollable>
		<div translate>login.no-app-access</div>
		<a href="mailto:ebusiness.support@arcelormittal.com">ebusiness.support@arcelormittal.com</a>
		<br>
		<button type="button" mat-button (click)="logout()">
			<span translate>login.logout</span>
		</button>
	</div>
</div>
<ng-template #loadingTpl>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>